import { useEffect, useState } from 'react'

export const titleWithUnread = (base: string, unread: number): string => (unread > 0 ? `(${unread}) ${base}` : base)

export const useUnreadTitle = (unread: number) => {
  const [base] = useState(() => document.title)

  useEffect(() => {
    document.title = titleWithUnread(base, unread)
  }, [base, unread])

  useEffect(
    () => () => {
      document.title = base
    },
    [base],
  )
}
